export default __webpack_public_path__ + "static/media/case_3.1dd1384e.jpg";